module.exports = __webpack_public_path__ + "img/get-ready-th.eeb87515.png";